// Mock data for Chainage Advisory clone

export const brand = {
  name: 'CHAINAGE',
  tag: 'ADVISORY',
  subtitle: 'Road Asset & Governance Advisory',
  ticker: 'CHAINAGE ADVISORY',
  tickerNote: 'Independent Infrastructure & Road Asset Advisory',
  location: 'Melbourne, VIC Australia',
  scope: 'National Advisory Scope (Australia-Wide)',
  email: 'contact@chainageadvisory.com.au',
};

export const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Experience', path: '/experience' },
  { label: 'About', path: '/about' },
  { label: 'Insights', path: '/insights' },
  { label: 'Contact', path: '/contact' },
];

export const metrics = [
  { value: '$20M+', label: 'Annual Program Scope', sub: 'Victoria\u2019s Road Management Framework', highlight: true },
  { value: '100%', label: 'Independent Auditing', sub: 'Unbiased Review' },
  { value: 'Senior-Led', label: 'Direct Advisor Access', sub: 'No Junior Handoffs' },
  { value: 'National', label: 'Australia-Wide Scope', sub: 'All States & Terr.', highlight: true },
];

export const services = [
  {
    id: '01',
    ref: 'CONTRACTOR-PERFORMANCE',
    category: 'Governance',
    icon: 'ClipboardCheck',
    title: 'Contractor Performance Management',
    description:
      'Independent KPI verification, contract compliance audits, and payment claim valuation for state road maintenance agreements.',
    deliverables: ['Monthly KPI scorecards', 'Payment claim valuation', 'Non-conformance reports', 'Contract variance analysis'],
  },
  {
    id: '02',
    ref: 'ROAD-ASSET-MANAGEMENT',
    category: 'Asset Management',
    icon: 'HardHat',
    title: 'Road Asset Management & Program Delivery',
    description:
      'Multi-year maintenance program scoping, asset lifecycle planning, and operational delivery governance under Victoria\u2019s Road Management and state frameworks.',
    deliverables: ['Lifecycle strategy', 'Program scoping', 'Budget optimisation', 'Delivery governance'],
  },
  {
    id: '03',
    ref: 'TGS-COMPLIANCE',
    category: 'Safety & Traffic',
    icon: 'ShieldAlert',
    title: 'TGS Review & Compliance',
    description:
      'Technical peer review of Traffic Guidance Schemes, Traffic Management Plans, and worksite safety compliance audits.',
    deliverables: ['TGS peer review', 'TMP audits', 'Site inspections', 'Worksite compliance reports'],
  },
  {
    id: '04',
    ref: 'SAFETY-BARRIER-ASSESSMENT',
    category: 'Safety & Traffic',
    icon: 'ShieldCheck',
    title: 'Road Safety Barrier Assessment',
    description:
      'MASH hardware compliance audits, roadside barrier condition inspections, and run-off-road hazard mitigation reviews.',
    deliverables: ['MASH compliance audit', 'Barrier condition report', 'Hazard mitigation plan', 'Terminal end review'],
  },
  {
    id: '05',
    ref: 'STAKEHOLDER-COUNCIL-ENGAGEMENT',
    category: 'Governance',
    icon: 'Users',
    title: 'Stakeholder & Council Engagement',
    description:
      'Inter-agency coordination, local council agreement alignment, and utility interface management during infrastructure works.',
    deliverables: ['Interface register', 'Council MoU review', 'Utility coordination', 'Comms protocol'],
  },
  {
    id: '06',
    ref: 'DATA-ANALYSIS-REPORTING',
    category: 'Analytics',
    icon: 'BarChart3',
    title: 'Infrastructure Data Analysis & Reporting',
    description:
      'Network condition data synthesis, defect trend analysis, pavement performance modeling, and executive board reporting.',
    deliverables: ['Condition data synthesis', 'Defect trend charts', 'Pavement modelling', 'Board-level reports'],
  },
];

export const backgroundWriteups = [
  {
    id: 'wu-01',
    tag: '$5M – $20M Annual Expenditure',
    title: '$5M\u2013$20M Network Maintenance Program Delivery',
    background:
      'Direct operational management of regional arterial road asset maintenance across high-tonnage freight corridors. Managed multi-million dollar annual allocations covering pavement resurfacing, cyclic roadside maintenance, drainage renewals, and emergency hazard response.',
    result:
      'Achieved 100% target compliance across core network safety KPIs, eliminated non-conformance penalties, and delivered the multi-million annual program within a 1.5% budget variance while improving overall road user safety scores.',
    featured: true,
  },
  {
    id: 'wu-02',
    tag: 'Tier-1 Consulting Sub-Engagement',
    title: 'Independent TGS Peer Review Program',
    background:
      'Engaged as an independent reviewer for a Tier-1 consultancy delivering a state-wide traffic guidance scheme uplift. Provided fortnightly peer reviews across 40+ active worksites.',
    result:
      'Reduced worksite incident reports by 34% over a 6-month review window, and eliminated repeat non-conformances across three regional depots.',
  },
  {
    id: 'wu-03',
    tag: 'MASH Barrier Compliance',
    title: 'Regional Barrier Network Compliance Audit',
    background:
      'Led a network-wide MASH compliance audit of roadside safety barriers, terminals, and transitions across a 480km rural arterial network.',
    result:
      'Delivered a prioritised remediation register covering 172 non-compliant assets, informing a $3.2M capital replacement program.',
  },
  {
    id: 'wu-04',
    tag: 'Executive Reporting',
    title: 'Board-Level Infrastructure Analytics Reporting',
    background:
      'Built defect trend analytics and pavement performance dashboards feeding directly into executive infrastructure board reporting cycles.',
    result:
      'Standardised monthly board reporting formats, improving governance visibility across three regional maintenance contracts.',
  },
];

export const testimonial = {
  quote:
    'This advisor brings an invaluable combination of field-level operational clarity and contract governance rigor. Their technical reviews of traffic guidance schemes and safety barrier compliance directly elevated our program\u2019s safety and contractor accountability standard.',
  author: 'Senior Program Manager',
  company: 'Major Infrastructure Advisory Practice | Infrastructure Delivery',
};

export const founder = {
  name: '',
  credentials: 'MEng (Distinction)',
  bio: "Master of Engineering (Deakin Univ) | B.Mech.Eng (VTU) | Specialist in Victoria\u2019s Road Management, Austroads, and MASH safety barrier standards.",
  yearsExperience: '6+',
  location: 'Melbourne, VIC',
};

export const capabilities = [
  { key: 'Victoria\u2019s Road Management & SLA Mastery', desc: 'Deep knowledge of performance maintenance contract frameworks.' },
  { key: 'Austroads & MASH Compliance', desc: 'Technical auditing of safety hardware and roadside barriers.' },
  { key: '$5M\u2013$20M Annual Scope', desc: 'Direct management of multi-year road maintenance programs.' },
  { key: 'Field-Verified Governance', desc: 'Payment claims validated against physical site conditions.' },
];

export const insights = [
  {
    id: 'in-01',
    date: '12 Jun 2026',
    category: 'Governance',
    title: 'The Payment Claim Gap: Why Field Verification Beats Desk Review',
    excerpt:
      'When contractor payment claims are reviewed only from documentation, agencies systematically overpay for cyclic maintenance. Field-verified quantities matter.',
    readTime: '6 min read',
    content: [
      'Desk-only review of monthly payment claims relies on the assumption that reported quantities reflect what was actually delivered on the network. In practice, this assumption breaks down on cyclic maintenance line items such as pothole patching, litter removal, and vegetation management, where physical evidence is short-lived and easily reconstructed on paper.',
      'A structured field-verification protocol \u2014 sampling claim line items against georeferenced site inspections, before-and-after imagery, and completion records \u2014 has repeatedly surfaced 4\u201311% variance between claimed and delivered quantities on the engagements we have supported.',
      'The purpose is not to catch out contractors. Well-run field verification improves both sides of the ledger: agencies pay for what was delivered, and contractors receive a defensible record when their claim is later challenged in audit. The upside is a payment file that survives treasury and parliamentary review without last-minute reconstruction.',
      'Practical starting point: pick two high-volume cyclic items, run parallel desk-and-field verification for one quarter, and compare variance. The evidence usually pays for the process within a single reporting cycle.',
    ],
  },
  {
    id: 'in-02',
    date: '02 May 2026',
    category: 'Safety',
    title: 'MASH Transitions: Where Australian Networks Still Fail',
    excerpt:
      'A network review of 480km of rural arterial found 41% of terminal transitions non-compliant. Here is what the audit taught us about renewal prioritisation.',
    readTime: '9 min read',
    content: [
      'Terminal ends and transitions between barrier systems remain the most common point of MASH non-compliance on Australian rural networks. The failure mode is rarely the barrier itself \u2014 it is the transition geometry, anchor detail, or terminal type retained from an earlier standard.',
      'On a recent 480km rural arterial audit, 41% of terminal transitions did not meet current MASH compliance. Of those, roughly one-third were straightforward like-for-like replacements; the remainder required minor earthworks or new anchor blocks.',
      'A prioritisation framework helps: rank non-compliant assets by run-off-road risk (traffic volume, geometry, crash history) rather than by asset age. This lets a capital replacement program focus on the transitions most likely to be struck, rather than distributing spend evenly.',
      'The audit informed a $3.2M capital replacement program sequenced over 24 months, with the highest-risk 20% of assets replaced in the first six months.',
    ],
  },
  {
    id: 'in-03',
    date: '18 Mar 2026',
    category: 'Program Delivery',
    title: 'Victoria\u2019s Road Management KPI Reporting: Beyond the Green-Tick Scorecard',
    excerpt:
      'Green scorecards can mask systemic contract underperformance. A framework for reading beneath the KPI surface for executive assurance.',
    readTime: '7 min read',
    content: [
      'A scorecard full of green ticks is comforting for an executive audience, but it is not the same as contract performance. Under Victoria\u2019s Road Management and comparable performance-based frameworks, KPIs are typically weighted, thresholded, and averaged in a way that allows persistent underperformance in one area to be offset by strong performance elsewhere.',
      'Three practical reads help executives look beneath the surface: (1) trend of borderline KPIs \u2014 metrics sitting just above threshold over multiple reporting periods often signal a structural issue; (2) response-time distributions rather than averages \u2014 a long tail indicates depot-level capacity gaps; (3) rework and re-inspection rates, which usually are not reported in the primary scorecard.',
      'None of these reads require additional data collection \u2014 they simply re-cut the data the contractor already provides. What they add is executive assurance grounded in evidence, not in green ticks.',
    ],
  },
  {
    id: 'in-04',
    date: '11 Feb 2026',
    category: 'Analytics',
    title: 'Pavement Deterioration Models Councils Actually Use',
    excerpt:
      'Simple, defensible modelling frameworks that local councils can operate without proprietary tooling \u2014 and still defend to auditors.',
    readTime: '8 min read',
    content: [
      'Sophisticated pavement deterioration models are widely published but rarely operated inside smaller local government asset teams. The barriers are less about maths and more about ongoing calibration, data hygiene, and the ability to defend the model to an auditor who did not build it.',
      'A defensible council-scale approach usually looks like this: segment the network by pavement type and traffic band; fit a simple exponential or piecewise-linear deterioration curve to condition survey data over three or more cycles; and re-baseline the model each time a new survey is completed rather than trying to project forward indefinitely.',
      'This is not the most accurate approach available, but it is one that a small asset team can operate, explain, and defend \u2014 which matters more for long-run governance than raw predictive accuracy.',
    ],
  },
];

export const partners = [
  'VicRoads Framework',
  'Austroads',
  'MASH Standard',
  'AS 1742.3',
  'Victoria\u2019s Road Management',
  'ISO 55001',
  'RMS NSW',
  'TMR QLD',
];

export const timeline = [
  { year: '2020', title: 'Field Foundations', desc: 'Site-level roadworks supervision on regional arterial corridors.' },
  { year: '2021', title: 'Program Coordination', desc: 'Coordinating cyclic maintenance across multiple regional depots.' },
  { year: '2022', title: 'Contract Governance', desc: 'Leading Victoria\u2019s Road Management contract KPI enforcement and payment claim auditing.' },
  { year: '2024', title: 'Network-Scale Delivery', desc: 'Managing $5M\u2013$20M annual maintenance programs.' },
  { year: '2025', title: 'Independent Practice', desc: 'Established Chainage Advisory for independent, senior-led engagements.' },
];
